export default __webpack_public_path__ + "static/media/ico-neptune-db-score-moderate.7f75a667.svg";